var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"breadcrumb",attrs:{"to":_vm.location}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('i',{staticClass:"fa fa-chevron-right fa-xs"})])}
var staticRenderFns = []

export { render, staticRenderFns }